// Funzioni pure di formattazione e riconoscimento, estratte da `main.ts` (Batch 1).
//
// Nessun side-effect, nessun accesso al DOM o a stato condiviso: input → output
// deterministico, testabili in isolamento (vedi scripts/test-frontend-pure.mjs).
// Comportamento identico a quello precedente in `main.ts`: solo spostamento.

// Tipi/estensioni HEIC-HEIF intercettati lato client (il backend comunque li rifiuta).
const HEIC_RE = /\.(heic|heif)$/i;

/** True se il file è HEIC/HEIF (per tipo MIME o estensione del nome). */
export function isHeic(file: File): boolean {
  return file.type === "image/heic" || file.type === "image/heif" || HEIC_RE.test(file.name);
}

/** Formatta una dimensione in byte come stringa leggibile (B / KB / MB). */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

/** Converte un ISO in valore per <input type="datetime-local"> (ora locale). */
export function toDatetimeLocal(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Escape dei caratteri HTML-sensibili per inserimento sicuro in markup. */
export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!,
  );
}

/** Formatta un ISO come data locale; "" se assente/invalido. */
export function formatDate(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString();
}

/** Formatta un ISO come orario locale (HH:MM); "" se assente/invalido. */
export function formatTime(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}
